import React from 'react';
import { BarLoader } from 'react-spinners';
import { css } from '@emotion/core';

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 100px;
`;

export default function Loading() {
  return (
    <div className="loading">
      <BarLoader css={override} color={'#dc3545'} />
    </div>
  );
}
